/**
 * Filete con motivo dorado central, inspirado en arabescos.
 * Usado para separar secciones y dar peso visual de marca.
 */
export default function Ornament({ size = 'md' }: { size?: 'sm' | 'md' | 'lg' }) {
  const w = size === 'sm' ? 14 : size === 'lg' ? 26 : 20;
  return (
    <div className="flex items-center justify-center gap-3 my-8 select-none">
      <span
        aria-hidden
        className="flex-1 h-px bg-gradient-to-r from-transparent via-elixir-gold/55 to-elixir-gold/55"
      />
      <svg
        width={w * 3}
        height={w}
        viewBox="0 0 60 20"
        className="text-elixir-gold"
        fill="none"
        stroke="currentColor"
        strokeWidth="1"
      >
        <path d="M0 10 L18 10" opacity="0.7" />
        <path d="M42 10 L60 10" opacity="0.7" />
        {/* Rombo central */}
        <path d="M30 2 L38 10 L30 18 L22 10 Z" fill="currentColor" fillOpacity="0.18" />
        <path d="M30 2 L38 10 L30 18 L22 10 Z" />
        {/* Punto central */}
        <circle cx="30" cy="10" r="1.2" fill="currentColor" />
      </svg>
      <span
        aria-hidden
        className="flex-1 h-px bg-gradient-to-l from-transparent via-elixir-gold/55 to-elixir-gold/55"
      />
    </div>
  );
}
